import React, { useState, useEffect } from "react";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const Disclaimer = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const hasAgreed = localStorage.getItem("lexceed_disclaimer_agreed");
        if (!hasAgreed) {
            setIsOpen(true);
        }
    }, []);

    const handleAgree = () => {
        localStorage.setItem("lexceed_disclaimer_agreed", "true");
        setIsOpen(false);
    };

    const handleDecline = () => {
        window.location.href = "https://www.google.com";
    };

    return (
        <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
            <AlertDialogContent className="bg-black/50 backdrop-blur-xl border border-gold/30 max-w-2xl shadow-[0_0_50px_-12px_rgba(212,175,55,0.3)]">
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-gold font-serif text-2xl border-b border-gold/20 pb-4">
                        Disclaimer & Confirmation
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-gray-300 text-base leading-relaxed pt-4">
                        By clicking <span className="text-gold font-semibold">“I Agree”</span> and continuing, you confirm you are visiting this website voluntarily for general information about <span className="text-white font-semibold">LEXCEED</span>, and that no advertisement, solicitation, invitation, or inducement has been made to you to create a lawyer–client relationship.
                        <br /><br />
                        The content on this site is for informational purposes only, may not be current or complete, and must not be treated as legal advice. <span className="text-white font-semibold">LEXCEED</span> disclaims liability for reliance on it, and you should seek independent counsel for any legal issue. External links (if any) are provided for convenience and are not endorsements, and by continuing you consent to our use of cookies.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="mt-8 flex flex-col sm:flex-row gap-4 sm:justify-end items-stretch sm:items-center">
                    <button
                        onClick={handleDecline}
                        className="flex-1 sm:flex-none px-10 py-4 border border-gold/40 text-gold-light/80 hover:text-gold hover:bg-gold/5 rounded-lg text-sm font-semibold transition-all duration-300 order-2 sm:order-1 h-[52px] flex items-center justify-center"
                    >
                        Decline
                    </button>
                    <AlertDialogAction
                        onClick={handleAgree}
                        className="flex-1 sm:flex-none bg-gradient-to-r from-gold to-gold-light text-black font-bold px-10 py-4 text-sm rounded-lg hover:shadow-2xl hover:shadow-gold/40 transform hover:scale-105 transition-all duration-300 order-1 sm:order-2 h-[52px] shadow-lg"
                    >
                        I Agree
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
